namespace RedBullMOBILE360.BulkSMS {
    export namespace PermissionKeys {
        export const REDBULLMOB = "BulkSMS:REDBULLMOB";
        export const RBMOBILEAD = "BulkSMS:RBMOBILE-AD";
    }
}
